import type { TFunction } from 'i18next';
import type { ReactNode } from 'react';

import {
  Box,
  IconPix,
  QRCode,
  Stack,
  StyleSheet,
  Typography,
} from '@woovi/pdf';

const styles = StyleSheet.create({
  heading: {
    marginTop: 25,
  },
  page: {
    padding: '32 20 52 20',
  },
  label: {
    fontSize: 8,
    textAlign: 'center',
  },
  labelSmall: {
    fontSize: 8,
    display: 'flex',
    flexWrap: 'wrap',
  },
  barCode: {
    marginTop: 10,
    maxWidth: 344,
  },
  leftColumn: {
    flexDirection: 'column',
    gap: '4px',
    padding: '4px 6px',
    width: 390,
  },
  rightColumn: {
    flexDirection: 'column',
    gap: '4px',
    borderLeft: '1px solid black',
    padding: '4px 6px',
    height: '100%',
  },
  rightColumnStacked: {
    flexDirection: 'column',
    gap: '4px',
    padding: '4px 6px',
  },
  valueSmall: {
    fontSize: '10px',
    width: 152,
  },
  value: {
    fontSize: '10px',
    textTransform: 'uppercase',
  },
});

const WrapText = ({ text }: { text?: string }): ReactNode => (
  <Box style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
    {text?.match(/\w+|\W+/g)?.map((seg, i) => (
      <Typography
        style={{
          fontSize: 8,
        }}
        key={i}
      >
        {seg}
      </Typography>
    ))}
  </Box>
);

type ChargePDFDocumentPixProps = {
  brCode: string;
  t: TFunction;
};

export const ChargePDFDocumentPix = ({
  brCode,
  t,
}: ChargePDFDocumentPixProps): ReactNode => {
  return (
    <Stack direction='row' style={{ justifyContent: 'space-between' }}>
      <Stack>
        <Stack direction='row' style={{ gap: 4 }}>
          <IconPix size={12} />
          <Typography style={styles.label}>{t('Pix Code')}</Typography>
        </Stack>
        <WrapText text={brCode} />
      </Stack>
      <Stack
        direction={'column'}
        style={{
          alignItems: 'center',
          width: 200,
          gap: 6,
        }}
      >
        <Stack direction='row' style={{ gap: 1, alignItems: 'center' }}>
          <IconPix size={12} />
          <Typography style={styles.label}>
            {t('Pay the invoice with Pix using the QR code below')}
          </Typography>
        </Stack>
        <Stack style={{ display: 'flex', justifyContent: 'center' }}>
          <QRCode qrcode={brCode} />
        </Stack>
      </Stack>
    </Stack>
  );
};
